import React from 'react';

interface FlexProps {
  gap?: string;
  wrap?: boolean;
  children: React.ReactNode;
}

const Flex: React.FC<FlexProps> = ({ gap = '0', wrap = false, children }) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: gap === 'middle' ? '1rem' : gap,
        flexWrap: wrap ? 'wrap' : 'nowrap',
      }}
    >
      {children}
    </div>
  );
};

export default Flex;
